module.exports = __webpack_public_path__ + "static/img/1-2.590f583.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/1-2.png
// module id = hNCG
// module chunks = 0